import { constants } from "../constants/redux-constants";

const initialState = {
  content: null, // The content to display (string or React component)
  type: null, // 'text' or 'component'
  isActive: false, // Whether custom content should be shown
};

const TopbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.APP.SET_TOPBAR_CONTENT:
      return {
        ...state,
        content: action.payload.content,
        type: action.payload.type,
        isActive: true,
      };
    
    case constants.APP.CLEAR_TOPBAR_CONTENT:
      return {
        ...state,
        content: null,
        type: null,
        isActive: false,
      };
    
    case constants.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default TopbarReducer;
